export const isValidForm = (formFields) => {
    for (var field of Object.values(formFields)) {
        if (field.length === 0) {
            return false
        }
    }
    return true
}